import React from 'react';
import './meditation-proper.css';

const MeditationProper = () => {
    return (
        <div id="meditation-proper" className="d-flex align-items-center justify-content-start">
            <div className="container fade-in-fwd">
                <div className="row d-flex align-items-center justify-content-center">
                    <div className="col-12 d-flex align-items-center justify-content-center">
                        <h1 className="text-white display-1 text-center my-display-1">Meditation Proper</h1>
                    </div>
                    <div className="col-12 d-flex align-items-center justify-content-center">
                        <h2 className="text-secondary display-4 text-center font-italic my-display-2">
                            A man's secret work
                        </h2>
                    </div>
                </div>
                <div className="row d-flex align-items-center justify-content-center">
                    <div className="col-12 pt-3 d-flex align-items-center justify-content-center">
                        <a name="meditation-proper" href="https://meditationproper.com/">
                            <button className="btn btn-lg btn-success">Learn More</button>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default MeditationProper;